/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'
import BigNumber from 'bignumber.js'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { referralCodeAtom, referralInfoAtom } from '@root/entities/referral'
import { processClaimReferralTransactionAction } from '@root/features/referral/atoms'
import { Error } from '@root/shared'
import { reatomAsyncResult } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { PaymentSourceWallet } from '@root/features/wallet'

export const reatomWithdrawReferral = () => {
  const withdrawWallet = atom<PaymentSourceWallet | undefined>(
    undefined,
    'withdrawWallet',
  )
  const withdrawAmount = atom<BigNumber>(BigNumber(0), 'withdrawAmount')
  const withdrawAmountAvailable = atom((ctx) => {
    const referralInfo = ctx.spy(referralInfoAtom)
    return referralInfo ? referralInfo.referralBalanceNative : BigNumber(0)
  }, 'withdrawAmountAvailable')

  const withdrawRequestStateAtom = reatomAsyncResult(async (ctx) => {
    const wallet = ctx.get(withdrawWallet)?.wallet
    const network = ctx.get(selectedNetworkAtom)
    if (!wallet) {
      return Result.fail(Error.UnknownError.fromUnknown('No wallet'))
    }
    const code = ctx.get(referralCodeAtom)
    if (!code) {
      return Result.fail(Error.UnknownError.fromUnknown('No referral code'))
    }

    const result_ = await ctx.schedule(() =>
      processClaimReferralTransactionAction(ctx, {
        wallet,
        network,
        amount: BigNumber(0),
        referralCode: code,
      }),
    )
    const result = Result.unify(result_)

    if (Result.isSuccess(result)) {
      showSnackbarAction(ctx, {
        text: i18next.t('referral.withdraw.processing.title'),
        intent: 'success',
      })
      return result
    } else {
      showErrorSnackbarAction(
        ctx,
        Error.UnknownError.fromUnknown(result.failure),
      )
    }

    return result
  })

  return {
    withdrawWallet,
    withdrawAmount,
    withdrawAmountAvailable,

    withdrawAction: withdrawRequestStateAtom.run,
    withdrawRequestStateAtom,
  }
}

export type WithdrawReferralModel = ReturnType<typeof reatomWithdrawReferral>
